export const getAllModules = ({
  editorStateSelectors
}) => {
  const {
    selectAllModules
  } = editorStateSelectors;
  return selectAllModules();
};